import { computed } from 'mobx';

export default class TagModel {
  id;
  store;

  constructor(store, tag) {
    this.store = store;
    this.id = +tag.id;
    this.name = tag.name;
    this.description = tag.description;
    this.parameters = tag.parameters;
    this.stations = tag.stations;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      description: this.description,
      parameters: this.parameters,
      stations: this.stations,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.description = json.description;
    this.parameters = json.parameters;
    this.stations = json.stations;
  }
}



// WEBPACK FOOTER //
// ./src/models/TagModel.js